import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_NOTIFICATION_SCHEMA = Object.freeze({
  TYPE: 'in_app', // web does not have any other values at the moment
  STATE: '',
  ACTION_URL: '',
});
const RECORD = generateSchema(TRACKING_NOTIFICATION_SCHEMA);
const KEYS: any = generateKeys(TRACKING_NOTIFICATION_SCHEMA);

export class NotificationTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.notification;
  }

  get properties() {
    return this.toJS();
  }
}
